import React, { useEffect, useState, Children } from 'react';

import './Carousel.css';

export const CarouselItem = ({ children, width }) => {
    return (
        <div className="carousel-item1" style={{ width: width }}>
            {children}
        </div>
    );
};

const Carousel = ({ children }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [paused, setPaused] = useState(false);

    const updateIndex = (newIndex) => {
        if (newIndex < 0) {
            newIndex = Children.count(children) - 1;
        } else if (newIndex >= Children.count(children)) {
            newIndex = 0;
        }

        setActiveIndex(newIndex);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (!paused) {
                updateIndex(activeIndex + 1);
            }
        }, 3000);

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeIndex, paused]);

    return (
        <div
            className="carousel"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
        >
            <div className="inner" style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
                {Children.map(children, (child, index) => {
                    return React.cloneElement(child, { width: '100%' });
                })}
            </div>

            {/* will use these when we get data through api */}
            <div className="indicators">
                {Children.map(children, (child, index) => {
                    return (
                        <button
                            className={`${index === activeIndex ? 'active' : ''}`}
                            onClick={() => {
                                updateIndex(index);
                            }}
                        ></button>
                    );
                })}
            </div>
        </div>
    );
};

export default Carousel;
